/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Tab_Top_UpsInputs */

const id_billing_tab_top_ups = /** @type {(inputs: Billing_Tab_Top_UpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riwayat top-up`)
};

const en_billing_tab_top_ups = /** @type {(inputs: Billing_Tab_Top_UpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top-up history`)
};

/**
* | output |
* | --- |
* | "Top-up history" |
*
* @param {Billing_Tab_Top_UpsInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_tab_top_ups = /** @type {((inputs?: Billing_Tab_Top_UpsInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Tab_Top_UpsInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_tab_top_ups(inputs)
	return id_billing_tab_top_ups(inputs)
});